import { useContext } from 'react';
import { makeStyles } from '@material-ui/core/styles';
import Box from '@material-ui/core/Box';
import Typography from '@material-ui/core/Typography';
import InfoIcon from '@material-ui/icons/Info';
import { WbButton } from '../../../WbButton';
import { WbSidebarItemWithSubmenuContext } from '../../config';
import { useAboutWitboostModal } from './useAboutWitboostModal';
import { WbTooltip } from '../../../WbTooltip';

const useStyles = makeStyles(
  theme => ({
    button: {
      height: 32,
      width: '100%',
      borderRadius: 4,
      padding: `0px 8px`,
      '&:hover': {
        background: theme.palette.bkg.primary,
      },
      display: 'flex',
      color: theme.palette.black,
      cursor: 'pointer',
      position: 'relative',
      background: 'none',
      border: 'none',
      justifyContent: 'flex-start',
      fontSize: theme.typography.body1.fontSize,
    },
    itemContainer: {
      width: '100%',
      padding: `0px 8px`,
    },
    label: {
      margin: theme.spacing(1.75),
      marginLeft: theme.spacing(1),
      fontSize: theme.typography.body1.fontSize,
      whiteSpace: 'nowrap',
      overflow: 'hidden',
      'text-overflow': 'ellipsis',
    },
  }),
  { name: 'AboutModalButton' },
);

export const AboutModalButton = () => {
  const classes = useStyles();
  const { openModal } = useAboutWitboostModal();
  const sidebarContext = useContext(WbSidebarItemWithSubmenuContext);
  const isSubmenuOpen = sidebarContext?.isSubmenuOpen ?? false;

  const handleClick = (event: React.MouseEvent<HTMLButtonElement>) => {
    event.preventDefault();
    openModal();
  };

  return (
    <Box className={classes.itemContainer}>
      <WbTooltip title="About Witboost" enterDelay={500} enterNextDelay={500}>
        <WbButton
          variant="text"
          aria-label="About Witboost"
          onClick={handleClick}
          className={classes.button}
          tabIndex={isSubmenuOpen ? 0 : -1}
          icon={<InfoIcon fontSize="small" />}
          label={
            <Typography
              variant="subtitle1"
              component="span"
              className={classes.label}
            >
              About Witboost
            </Typography>
          }
        />
      </WbTooltip>
    </Box>
  );
};
